import * as React from 'react';
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Layout } from "antd";
import { EnhancedProps } from 'src/pages/student/models/props';

const { Content } = Layout;

interface Landing1Props extends EnhancedProps {
}

class Landing1 extends React.Component<Landing1Props> {
    constructor(props: Landing1Props) {
        super(props);
        bindAllOfThis(this, Landing1.prototype);
    }

    onNext() {
        this.props.onNext();
    }

    componentDidMount() {
        document.body.classList.add("pod-to-planet");

        setTimeout(() => {
            this.onNext();
        }, 2750);
    }

    componentWillUnmount(): void {
        document.body.classList.remove("pod-to-planet");
    }

    render() {
        let code = this.props.currentPlanet.name.toLowerCase();
        let podClassName = `star-pod star-pod-${code}`;
        let planetClassName = `planet planet-${code}`;
        this.props.onChangeAudio("");

        return <Content style={{ height: '100vh', overflow: 'hidden' }}>
            <div id="star-pod" className={podClassName} />
            <div id="planet" className={planetClassName} />
        </Content>;
    }
}

export default Landing1;



// WEBPACK FOOTER //
// ./src/pages/student/scenes/Landing1.tsx